const ACTIONS = {
    FETCH_SENTIMENT_HIGHLIGHTS: 'TRAVELER_SENTIMENTS/FETCH_SENTIMENT_HIGHLIGHTS',
    FETCH_SENTIMENT_HIGHLIGHTS_SUCCESS: 'TRAVELER_SENTIMENTS/FETCH_SENTIMENT_HIGHLIGHTS_SUCCESS'
};

const ACTION_CREATORS = {
    fetchSentimentHighlights(crisisType) {
        return {
            type: ACTIONS.FETCH_SENTIMENT_HIGHLIGHTS,
            payload: {
                crisisType
            }
        };
    },
    fetchSentimentHighlightsSuccess(travelerSentiments) {
        return {
            type: ACTIONS.FETCH_SENTIMENT_HIGHLIGHTS_SUCCESS,
            payload: {
                travelerSentiments
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
